import React, { useState } from "react";

// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import Button from "../CustomButtons/Button.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

// sections for this page
import ForumsTopicCard from "../ForumsTopicCard/ForumsTopicCard.js";
import ForumsNoReplies from "../ForumsNoReplies/ForumsNoReplies.js";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons/faCircleNotch";
import {CommentProvider, useCommentContext} from "../../contexts/comment";
import ForumsLoginBarrier from "../ForumsLoginBarrier/ForumsLoginBarrier";

const useStyles = makeStyles()(styles);

export default function ForumsTopicReplies(props) {
  const { classes, cx } = useStyles();
  const topic = props.data;
  const initial = props.initial;
  const community = props.community;
  const { repliesExpanded, setRepliesExpanded, reload, threadClosed, showLoginBarrier = false } = props;

  const { comments, isLoadingComments, reloadComments, shouldFetchComments } = useCommentContext() ?? {};

  const replies = comments?.replies ?? props.replies ?? [];

  const replyData = replies.map((reply) => {
    return {
      ...reply,
      tags: [],
      topicTitle: "",
    };
  });
  const replyCount = comments?.replyCount ?? topic.replyCount;

  return (
    <div
      className={classes.replies}
      style={{
        ...(showLoginBarrier ? { minHeight: "220px", maxHeight: "500px", overflowY: "hidden" } : { }),
        ...(repliesExpanded ? { paddingBottom: "10px" } : { paddingBottom: "20px" }),
      }}
    >
      {initial === true && (
        <h3 className={classes.repliesTitle}>{replyCount} replies</h3>
      )}
      {initial === true && replyCount === 0 && !threadClosed && (
        <ForumsNoReplies topic={topic} />
      )}
      {replyCount > 0 && (
        <Button
          onClick={() => setRepliesExpanded(!repliesExpanded)}
          className={initial === true ?  classes.hidden : cx(classes.lightButton + " " + classes.repliesButton)}
        >
          {isLoadingComments ? (
            <FontAwesomeIcon
              icon={faCircleNotch}
              className={classes.repliesButtonIcon}
              spin={true}
            />
          ) : repliesExpanded ? (
            <FontAwesomeIcon
              icon={faChevronUp}
              className={classes.repliesButtonIcon}
            />
          ) : (
            <FontAwesomeIcon
              icon={faChevronDown}
              className={classes.repliesButtonIcon}
            />
          )}
          {replyCount} replies
        </Button>
      )}
      {(repliesExpanded || initial === true) && <>
        {replyData.map((reply, index) => {
          return (
            <ForumsTopicCard
              type="comment"
              replies={reply.replies}
              topic={reply}
              postView={true}
              key={index}
              initial={false}
              community={community}
              reload={shouldFetchComments ? reloadComments : reload}
              parentThreadClosed={threadClosed}
            />
          );
        })}
        {showLoginBarrier && replyData.length > 0 && <>
          <ForumsLoginBarrier />
        </>}
      </>}
    </div>
  );
}
